/*=========================================================================================
  File Name: index.js
  Namespace: rating
  Description: Vuex Rating Store
==========================================================================================*/

import {
  getCSVExport,
  listRatings,
  ratingSumary,
} from '@/services/ratings.service.js'

const state = {
  ratingsByInstructor: {},
  ratingsByContent: {},
}

const mutations = {
  STORE_INSTRUCTOR_RATING(state, rating) {
    state.ratingsByInstructor = {
      ...state.ratingsByInstructor,
      ...rating,
    }
  },
  STORE_CONTENT_RATING(state, rating) {
    state.ratingsByContent = {
      ...state.ratingsByContent,
      ...rating,
    }
  },
}

const actions = {
  async searchRatings(context, params = {}) {
    const response = await listRatings(params)

    return response
  },
  async getRatingsCSV(context, params = {}) {
    const response = await getCSVExport(params)
    return response
  },
  async getRatingSummary(context, params = {}) {
    let response = {}

    if (params.model_id) {
      context.commit('STORE_CONTENT_RATING', {
        [params.model_id]: response,
      })

      response = await ratingSumary(params)

      context.commit('STORE_CONTENT_RATING', {
        [params.model_id]: response,
      })
    } else if (params.instructor) {
      context.commit('STORE_INSTRUCTOR_RATING', {
        [params.instructor]: response,
      })

      response = await ratingSumary(params)

      context.commit('STORE_INSTRUCTOR_RATING', {
        [params.instructor]: response,
      })
    }

    return response
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
